import socketConnector from 'sockets';
import _ from 'lodash';

let socket;

export function getSocketconnection(props) {
    let retries = 0;

    function connectSocket() {
        socket = socketConnector.connect(_.pick(props, ['userId']));
    }

    function reconnect() {
        if (retries < 3 && !socket) {
            connectSocket();
            retries++;
            if (!socket) {
                reconnect();
            }
        }
    }

    reconnect();

    return socket;
}


// WEBPACK FOOTER //
// ./app/helpers/socket.js